import {
  isValidChecksumAddress,
  isValidPrivate as _isValidPrivate,
  privateToAddress,
  publicToAddress,
  toChecksumAddress,
} from '@exodus/ethereumjs/util'
import assert from 'minimalistic-assert'

export const validateFactory = ({ chainId, useEip1191ChainIdChecksum }) => {
  assert(
    chainId || !useEip1191ChainIdChecksum,
    'chainId is required when useEip1191ChainIdChecksum is true'
  )
  return (address) => {
    if (typeof address !== 'string') return false

    // https://github.com/ethereumjs/ethereumjs-util/issues/54
    if (address.slice(0, 2) !== '0x' || address.length !== 42) return false

    if (!hasChecksum(address)) return true

    return (
      (useEip1191ChainIdChecksum && isValidChecksumAddress(address, chainId)) ||
      isValidChecksumAddress(address)
    )
  }
}

export function hasChecksum(address) {
  return !(/^0x[\dA-F]{40}$/.test(address) || /^0x[\da-f]{40}$/.test(address))
}

export function encodePrivate(privKey) {
  return '0x' + privKey.toString('hex')
}

export const encodePublicFactory = ({ chainId, useEip1191ChainIdChecksum }) => {
  assert(
    chainId || !useEip1191ChainIdChecksum,
    'chainId is required when useEip1191ChainIdChecksum is true'
  )
  return (compressedPubKey) => {
    const hash160bits = publicToAddress(compressedPubKey, true)

    const basicAddress = toChecksumAddress(
      '0x' + hash160bits.toString('hex'),
      useEip1191ChainIdChecksum ? chainId : undefined
    )
    return useEip1191ChainIdChecksum ? basicAddress.toLowerCase() : basicAddress
  }
}

export function isValidPrivate(privateKey) {
  return privateKey.length === 32 && _isValidPrivate(privateKey)
}

export const encodePublicFromPrivateFactory = ({ chainId, useEip1191ChainIdChecksum }) => {
  assert(
    chainId || !useEip1191ChainIdChecksum,
    'chainId is required when useEip1191ChainIdChecksum is true'
  )
  return (privateKey) => {
    return toChecksumAddress(
      '0x' + privateToAddress(privateKey).toString('hex'),
      useEip1191ChainIdChecksum ? chainId : undefined
    )
  }
}

// back compatiblity (except rsk)
export const validate = validateFactory({})
export const encodePublic = encodePublicFactory({})
export const encodePublicFromPrivate = encodePublicFromPrivateFactory({})
